import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Schedule from '../views/admin/Schedule.vue'
import moment from 'moment'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/tv',
        name: 'tv',
        component: () => import(/* webpackChunkName: "about" */ 'topvue/views/TV.vue')
    },
    {
        path: '/admin/schedule/:date',
        name: 'admin:schedule',
        component: Schedule
    },
    {
        path: '/admin/schedule/',
        name: 'admin:schedule_redirect',
        redirect: () => {
            return '/admin/schedule/' + moment().format('YYYY-MM-DD') + '/'
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    routes,
})

export default router
